module.exports = window["__sharedAtgSticky"];